module.exports = __webpack_public_path__ + "d1daa53f406a1fd1a0c45fecae4bec66.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/fr.json
// module id = 1131
// module chunks = 0